import { Controller } from "@hotwired/stimulus"

// Shows optional quantity min/max fields when "customer enters quantity" is on.
export default class extends Controller {
  static targets = ["toggle", "bounds"]
  static classes = ["hidden"]

  connect() {
    this.sync()
  }

  sync() {
    if (!this.hasToggleTarget || !this.hasBoundsTarget) return

    this.boundsTarget.classList.toggle(this.hiddenClass, !this.toggleTarget.checked)
  }
}
